import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-3">
            精彩速看
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            精选合集推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500">编辑精选的漫画主题合集，发现更多精彩作品</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaData.map((item) => (
            <a
              key={item.title}
              href="#ranking"
              className="group cursor-pointer"
            >
              <div className="relative rounded-xl overflow-hidden aspect-[3/4] bg-background-100">
                <img
                  src={item.cover}
                  alt={`女神漫画 ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-background-50/90 text-foreground-800 rounded-full">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent p-4 pt-10">
                  <h3 className="text-sm font-medium text-background-50 leading-snug">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-1 mt-1 text-xs text-background-200">
                    <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center" />
                    <span>{item.views} 浏览</span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}